import { RemoteCreateSector } from 'data/usecases';
import { makeApiUrlSectors } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeRemoteCreateSector = (): RemoteCreateSector => {
  return new RemoteCreateSector(makeApiUrlSectors(), makeAxiosHttpClient());
};
